"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _textWidthMeasurer = _interopRequireDefault(require("../../../../utils/text-width-measurer"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //helpers
//lodash
//styled-components
//constants
var safeCaretWidth = 4; // in some browsers text caret occupies space
var safeFallbackWidth = '6em';
var UnderlinedTextboxComponent = exports["default"] = /*#__PURE__*/function (_Component) {
  function UnderlinedTextboxComponent() {
    var _this;
    _classCallCheck(this, UnderlinedTextboxComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UnderlinedTextboxComponent, [].concat(args));
    _defineProperty(_this, "measurer", null);
    _defineProperty(_this, "inputElement", null);
    _defineProperty(_this, "calculateWidth", function () {
      var placeholder = _this.props.placeholder;
      if (_this.inputElement.value) {
        var width = _this.measurer.measure(_this.inputElement.value) + safeCaretWidth;
        return "".concat(width, "px");
      }
      if (placeholder) {
        var _width = _this.measurer.measure(placeholder) + safeCaretWidth;
        return "".concat(_width, "px");
      }
      return safeFallbackWidth;
    });
    _defineProperty(_this, "handleInnerRef", function (instance) {
      var autoFocus = _this.props.autoFocus;
      _this.inputElement = instance;
      if (_this.inputElement && autoFocus) {
        _this.inputElement.focus();
      }
    });
    _defineProperty(_this, "handleInput", function (event) {
      var onInput = _this.props.onInput;
      _this.updateWidth();
      if (typeof onInput === 'function') {
        onInput.call(_this.inputElement, event);
      }
    });
    _defineProperty(_this, "setCustomValidity", function (message) {
      if (!_this.inputElement) {
        return;
      }
      if (message && message !== 'validating...') {
        _this.inputElement.setCustomValidity(message);
      } else {
        _this.inputElement.setCustomValidity('');
      }
    });
    /**
     * Updates width to contain the value
     */
    _defineProperty(_this, "updateWidth", function () {
      if (!_this.measurer || !_this.inputElement) {
        return;
      }
      _this.inputElement.style.width = _this.calculateWidth();
    });
    return _this;
  }
  _inherits(UnderlinedTextboxComponent, _Component);
  return _createClass(UnderlinedTextboxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var error = this.props.error;
      this.setCustomValidity(error);
      this.measurer = new _textWidthMeasurer["default"](this.inputElement);
      this.updateWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        error = _this$props.error,
        placeholder = _this$props.placeholder,
        value = _this$props.value;
      if (prevProps.error !== error) {
        this.setCustomValidity(error);
      }
      if (prevProps.placeholder !== placeholder || prevProps.value !== value) {
        this.updateWidth();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.measurer.destroy();
    }
  }, {
    key: "render",
    value: function render() {
      var forwardedProps = (0, _omit["default"])(this.props, 'autoFocus', 'error');
      return /*#__PURE__*/_react["default"].createElement(_styles.StyledInput, _extends({}, forwardedProps, {
        ref: this.handleInnerRef,
        onInput: this.handleInput
      }));
    }
  }]);
}(_react.Component);
_defineProperty(UnderlinedTextboxComponent, "defaultProps", {
  autoFocus: false,
  type: 'text'
});
_defineProperty(UnderlinedTextboxComponent, "propTypes", {
  autoFocus: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(['password', 'search', 'text', 'url']),
  onChange: _propTypes["default"].func,
  onInput: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  value: _propTypes["default"].string
});
//# sourceMappingURL=index.js.map